export const LOGIN = 'AUTH/LOGIN';
export const LOGOUT = 'AUTH/LOGOUT';

/**
 * Met à jour l'id de l'utilisateur connecté.
 * @param {Object{}} result Jetons de l'utilisateur
 */
export function setUser(result) {
  return {
    type: LOGIN,
    result,
  };
}

/**
 * Déconnexion de l'utilisateur.
 */
export function logout() {
  return {
    type: LOGOUT,
  };
}
